import Vue from 'vue';
import VTooltip from 'v-tooltip';
import dayjs from 'dayjs';
import NProgress from 'nprogress';
import Notifications from 'vue-notification';
import io from 'socket.io-client';
import VueSocketio from 'vue-socket.io-extended';
import VueSplit from 'vue-split-panel';
import VueHotkey from 'v-hotkey';
import browserDetect from 'vue-browser-detect-plugin';
import ReadMore from 'vue-read-more';
import VueClazyLoad from 'vue-clazy-load';
// eslint-disable-next-line
import vueXlsxTable from 'vue-xlsx-table';
import {
	MdField,
	MdButton,
	MdIcon,
	MdRadio,
	MdCheckbox,
	MdDatepicker,
	MdMenu,
	MdList,
	MdDivider,
	MdDialog,
	MdContent,
	MdSwitch,
	MdChips,
	// MdMenuContent,
	// MdSubheader,
	// MdProgress,
} from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
// import 'vue-material/dist/theme/default.css';

import '../node_modules/nprogress/nprogress.css';

import App from './App.vue';
import router from './router';
import store from './store';
import {
	i18n,
	loadLanguageAsync,
} from './setup/i18n-setup';
import './registerServiceWorker';
import noLocale from './lib/locale/no';
// eslint-disable-next-line import/order
import AxiosPlugin from 'vue-axios-cors';

dayjs.locale(noLocale);
dayjs.locale('en');

Vue.config.productionTip = false;

const SOCKET_URL = process.env.VUE_APP_SOCKET_URL || 'http://localhost:3000';

// Socket
const socket = io(SOCKET_URL, {
	transports: ['websocket'],
	// reconnection: true, // whether to reconnect automatically
	// reconnectionAttempts: Infinity, // number of reconnection attempts before giving up
	// reconnectionDelay: 1000, // how long to initially wait before attempting a new reconnection
	// reconnectionDelayMax: 5000, // maximum amount of time to wait between reconnection attempts. Each attempt increases the reconnection delay by 2x along with a randomization factor
	// randomizationFactor: 0.5,
});
Vue.directive('uppercase', {
	update(el) {
		// eslint-disable-next-line no-param-reassign
		el.value = el.value.toUpperCase();
	},
});

Vue.use(VueSplit);
Vue.use(VueSocketio, socket, { store });
Vue.use(VTooltip);
Vue.use(vueXlsxTable, { rABS: false });
Vue.use(Notifications);
Vue.use(browserDetect);
Vue.use(VueClazyLoad);
Vue.use(require('vue-shortkey'));

// Material Design Components
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdIcon);
Vue.use(MdRadio);
Vue.use(MdCheckbox);
Vue.use(MdDatepicker);
Vue.use(MdMenu);
// Vue.use(MdMenuContent);
Vue.use(MdList);
Vue.use(MdDivider);
Vue.use(MdDialog);
Vue.use(MdContent);
Vue.use(MdSwitch);
Vue.use(MdChips);
Vue.use(AxiosPlugin);

// Vue.use(MdSubheader);
// Vue.use(MdProgress);
Vue.use(VueHotkey, {
	one: 49, // the key code of character '1'
	two: 50,
	three: 51,
	four: 52,
	five: 53,
	six: 54,
	seven: 55,
	eight: 56,
	nine: 57,
	zero: 48,
	minus: 189,
	plus: 187,
	closeModal: 27,
});
Vue.use(ReadMore);
// Route Middleware
router.beforeEach((to, from, next) => {
	const { path } = to;
	const { isLoggedIn } = store.getters;

	const errors = [];

	const alreadyLoggedIn = path === '/login' && isLoggedIn;
	if (alreadyLoggedIn) errors.push('already_logged_in');
	const alreadyLoggedIn2 = path === '/register' && isLoggedIn;
	if (alreadyLoggedIn2) errors.push('already_logged_in');
	const alreadyLoggedIn3 = path === '/user/verify' && isLoggedIn;
	if (alreadyLoggedIn3) errors.push('already_logged_in');


	const isNotAvailable = errors.length > 0;
	// const displayLive = path.name === DisplayLive
	// const allowedPaths = [
	// 	'/',
	// 	'/login',
	// 	'/logout',
	// 	'/password/reset',
	// 	'/register',
	// 	'/magic-link',
	// 	'/change-password',
	// 	'/auto_login',
	// 	'/user/verify',
	// 	'/confirmation-email',
	// ];
	const isDisplayLive = to.name === 'DisplayLive';
	const isDisplayMulti = to.name === 'MultiviewOutputDisplay';
	const isDisplayLightStream = to.name === 'LightStream';
	if (path === '/callback' || isDisplayMulti) {
		next();
	} else if (path === '/callback' || isDisplayLive) {
		next();
	} else if (path === '/callback' || isDisplayLightStream) {
		next();
	} else if (isNotAvailable) {
		next('/');
	} else {
		next();
	}
});

// Change Title
router.beforeEach((to, from, next) => {
	store.dispatch('navigate', { to });
	const title = to.meta.title || '';
	document.title = title;
	next();
});

// Lazy load Languages
router.beforeEach((to, from, next) => {
	const lang = to.query.lang || store.getters.locale;
	loadLanguageAsync(lang).then(() => next());
});

router.beforeResolve((to, from, next) => {
	if (to.name) {
		NProgress.start();
	}
	next();
});

router.afterEach(() => {
	NProgress.done();
});

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');
